import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Loader from 'components/loader'
import Dialoguemodal from 'components/dialoguemodal'
import SearchList from 'components/search-list'
import { currencyFormat, formateDate } from 'utils'
import { ordersApi } from '../restaurant.api'
import { OrdersProvider, useOrders, ORDER_STATUSES } from './orders.context'
import OrderDetail from './order-detail'

const STATUS_TONES = {
  Pending: 'tw-bg-[#FBF1DE] tw-text-[#7F5F1E]',
  Confirmed: 'tw-bg-[#FFEDE7] tw-text-[#C4341A]',
  Preparing: 'tw-bg-[#FFEDE7] tw-text-[#C4341A]',
  'Out For Delivery': 'tw-bg-[#F1E7EE] tw-text-[#6E4159]',
  Delivered: 'tw-bg-[#E6F0E9] tw-text-[#3F7A56]',
  Cancelled: 'tw-bg-[#FBE9E7] tw-text-[#C0392B]',
}

function OrdersInner() {
  const {
    loading,
    orders,
    setSearch,
    statusFilter,
    setStatusFilter,
    refresh,
  } = useOrders()
  const navigate = useNavigate()
  const [viewing, setViewing] = useState(null)

  const changeStatus = async (order, status) => {
    const { response } = await ordersApi.updateStatus(order._id, status)
    if (response?.success) refresh()
  }

  return (
    <div>
      <div className='tw-mb-4'>
        <button
          onClick={() => navigate('/order-management')}
          className='tw-text-[12px] tw-text-gray-400'
        >
          ← Order management
        </button>
        <h2 className='font-heading tw-text-2xl'>Orders</h2>
      </div>

      <div className='tw-mb-6 tw-flex tw-flex-wrap tw-items-center tw-gap-3'>
        <SearchList search={(e) => setSearch(e.target.value)} />
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className='tw-p-2 tw-text-sm tw-rounded-[8px] tw-bg-white tw-border tw-border-gray-200'
        >
          <option value=''>All statuses</option>
          {ORDER_STATUSES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <Loader />
      ) : orders.length ? (
        <div className='tw-flex tw-flex-col tw-gap-3'>
          {orders.map((order) => (
            <div
              key={order._id}
              className='tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-py-3 tw-px-3 tw-rounded-[8px] tw-border tw-border-[#E7DFD9] tw-bg-white'
            >
              <div className='tw-flex-1 tw-min-w-[160px]'>
                <p className='tw-font-mono tw-font-semibold tw-text-[13px] tw-text-navyBlue'>
                  {order.orderNumber}
                </p>
                <p className='tw-text-xs tw-text-gray-500'>
                  {order.customerInfo?.name} · {order.customerInfo?.phone}
                </p>
                <p className='tw-text-[11px] tw-text-gray-400'>
                  {formateDate(order.createdAt)} ·{' '}
                  {(order.items || []).length} item(s)
                </p>
              </div>
              <div className='tw-font-bold tw-text-sm'>
                {currencyFormat(order.totalAmount || 0)}
              </div>
              <span
                className={`tw-text-[10px] tw-px-[7px] tw-py-[3px] tw-rounded-[3px] tw-whitespace-nowrap ${STATUS_TONES[order.status] || 'tw-bg-gray-100 tw-text-gray-500'}`}
              >
                {order.status}
              </span>
              <select
                value={order.status}
                onChange={(e) => changeStatus(order, e.target.value)}
                className='tw-p-1.5 tw-text-xs tw-rounded-[6px] tw-bg-white tw-border tw-border-gray-200'
              >
                {ORDER_STATUSES.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
              <button
                type='button'
                onClick={() => setViewing(order)}
                className='tw-text-[12px] tw-px-[10px] tw-py-[4px] tw-rounded-[5px] tw-border tw-border-gray-300 tw-text-gray-600'
              >
                View
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className='tw-text-center tw-text-gray-400 tw-py-16'>
          No orders found
        </div>
      )}

      <Dialoguemodal
        open={!!viewing}
        onClose={() => setViewing(null)}
        title='Order details'
      >
        {viewing && <OrderDetail order={viewing} />}
      </Dialoguemodal>
    </div>
  )
}

function Orders() {
  return (
    <OrdersProvider>
      <OrdersInner />
    </OrdersProvider>
  )
}

export default Orders
